var exports = {};
exports = {
  BRAINTREE_VERSION: "2018-05-10"
};
export default exports;